const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export function getToken(): string | null {
  return localStorage.getItem('cs_admin_token')
}

export function setToken(t: string) {
  localStorage.setItem('cs_admin_token', t)
}

export function clearToken() {
  localStorage.removeItem('cs_admin_token')
  localStorage.removeItem('cs_admin_user')
}

export async function apiFetch<T = any>(
  path: string,
  opts: RequestInit = {}
): Promise<T> {
  const token = getToken()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(opts.headers as Record<string, string>),
  }
  if (token) headers.Authorization = `Bearer ${token}`

  const res = await fetch(`${API_URL}${path}`, { ...opts, headers })
  if (res.status === 401) {
    clearToken()
    if (!path.includes('/auth/')) window.location.href = '/admin/login'
    throw new Error('Unauthorized')
  }
  if (!res.ok) {
    const err = await res.text()
    throw new Error(err || `HTTP ${res.status}`)
  }
  return res.json()
}

export const api = {
  login: (username: string, password: string) =>
    apiFetch<{ access_token: string; user: any }>('/api/v1/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    }),
  me: () => apiFetch<any>('/api/v1/auth/me'),
  stats: () => apiFetch<any>('/api/v1/admin/stats'),
  events: (params: Record<string, any> = {}) => {
    const q = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null) as any
    ).toString()
    return apiFetch<any>(`/api/v1/admin/events${q ? `?${q}` : ''}`)
  },
  eventDetail: (id: number) => apiFetch<any>(`/api/v1/admin/events/${id}`),
  visitors: () => apiFetch<any>('/api/v1/admin/visitors'),
  visitorDetail: (visitorId: string) =>
    apiFetch<any>(`/api/v1/admin/visitors/${encodeURIComponent(visitorId)}`),
  gmailLogins: () => apiFetch<any>('/api/v1/admin/gmail-logins'),
  gmailByEmail: (email: string) =>
    apiFetch<any>(`/api/v1/admin/gmail-logins/by-email/${encodeURIComponent(email)}`),
  live: () => apiFetch<any>('/api/v1/admin/live'),
  countries: () => apiFetch<any>('/api/v1/admin/countries'),
}
